import React from "react";
import * as T from "./types";
import * as S from "./styles";
import { Context } from '@routes/private/Editor/Context';
import { AuthContext } from "@utils/DOIgnition/AuthContext";
import { useDispatch, useSelector } from "react-redux";
import DealerSelect from "@components/DealerSelect";
import actions from "@state/actions";
import selectors from "@state/selectors";
import { getDealerAssets, getDealerCollections, getDealerAssetsNames } from "@state/dealers/utils";
import { IDealerCollection } from "@state/dealers/types";
import Loading from "@components/Loading";
import ComboBox from "@components/ComboBox";
import Button from "@components/Button";
import AssetsExplorer from "./AssetsExplorer";
import AssetsNames from "./AssetsNames";
import { IExportingArtboardNames, IExportingProperties } from "@routes/private/Editor/types";
import { delay } from "lodash";
import { IDSConfig } from "@state/dsconfig/types";
import { Group } from "konva/lib/Group";
import WarningIcon from "@assets/icons/warningIcon";
import { NOT_ALLOWED_COLLECTIONS } from "./types";
import { IUserType } from "@state/auth/types";

const GalleryExport: React.FC<T.IProps> = (props) => {

  const dispatch = useDispatch();
  const authContext = React.useContext(AuthContext);
  const dsConfig: IDSConfig | undefined = useSelector(selectors.dsConfig.getDSConfig)
  const dealers = useSelector(selectors.dealers.getDealers);
  const { onExportingPropsChange, editorStatus } = React.useContext(Context);

  const [selectedCollection, setSelectedCollection] = React.useState<IDealerCollection>();
  const [selectedFolder, setSelectedFolder] = React.useState<string>();
  const [isSearchingCollections, setIsSearchingCollections] = React.useState(false);
  const [isSearchingAssets, setIsSearchingAssets] = React.useState(false);
  const [isUpdatingNamesAssets, setIsUpdatingNamesAssets] = React.useState(false);
  const [askOverwrite, setAskOverwrite] = React.useState(false);
  const [overwriteAssets, setOverwriteAssets] = React.useState(false);
  const [hasChanges, setHasChanges] = React.useState(false);
  const [newFolderControls, setNewFolderControls] = React.useState(false);
  const [folderName, setFolderName] = React.useState("");
  const [repeatedName, setRepeatedName] = React.useState(false);
  const [emptyFolderPrefix, setEmptyFolderPrefix] = React.useState<string>();
  const [overcomeSize, setOvercomeSize] = React.useState(false);


  const updateCollections = async () => {
    if (!isSearchingCollections && dealers.selectedDealer?.id && authContext) {
      setIsSearchingCollections(true);
      try {
        dispatch(actions.dealers.setDealerAssets({prefix: null, assets: [], folders: []}));
        props.exportingProperties.dealerId = dealers.selectedDealer.id;
        props.exportingProperties.collection = undefined;
        props.exportingProperties.prefix = undefined;
        setSelectedCollection(undefined);
        setSelectedFolder(undefined);
        onExportingPropsChange(props.exportingProperties);
        await getDealerCollections(dispatch, {
          dealerId: dealers.selectedDealer.id,
          access_token: authContext.userData.access_token,
        });
        setIsSearchingCollections(false);
      } catch (error) {
        console.error(error);
        setIsSearchingCollections(false);
      }
    }
  }

  const handleSelectCollection = (id: string, value: string) => {
    if (dealers.collections) {
      const collection = dealers.collections.find(c => c.name === value);
      if (collection) {
        setSelectedCollection(collection);
        dispatch(actions.dealers.setDealerAssets({prefix: null, assets: [], folders: []}));
        props.exportingProperties.collection = collection.id;
        props.exportingProperties.prefix = undefined;
        setSelectedFolder(undefined);
        onExportingPropsChange(props.exportingProperties);
      }
    }
  }


  const updateAssetsNames =  async (exportingNames?:string[],folder?: string) => {
    if (dealers.selectedDealer?.id && authContext && selectedCollection && props.exportingProperties.names) {
      setIsUpdatingNamesAssets(true);      
      if (!exportingNames)
      {
        exportingNames = props.exportingProperties.names.map(n=>{
          return n.name
        });
      }

      try {
        await getDealerAssetsNames(dispatch, {
          dealerId: dealers.selectedDealer.id,
          collection: selectedCollection.id,
          prefix: folder ?? "",
          access_token: authContext.userData.access_token,
          //names:  props.exportingProperties.artboardsNames??[]
          names: exportingNames
        });
        
      } catch (error) {
        console.error(error);
        
      }
    }
  }

  const updateAssets = async (folder?: string) => {
    setEmptyFolderPrefix(undefined);
    setNewFolderControls(false);
    if (!isSearchingAssets && dealers.selectedDealer?.id && authContext && selectedCollection) {
      setIsSearchingAssets(true);
      try {
        await getDealerAssets(dispatch, {
          dealerId: dealers.selectedDealer.id,
          collection: selectedCollection.id,
          prefix: folder ?? "",
          access_token: authContext.userData.access_token,
        });
        props.exportingProperties.prefix = folder;
        onExportingPropsChange(props.exportingProperties);
        setSelectedFolder(undefined);
        setIsSearchingAssets(false);
      } catch (error) {
        console.error(error);
        setIsSearchingAssets(false);
      }
    }
    
    updateAssetsNames(undefined,folder);
  }

  const updatePrefix = (clean?: boolean) => {
    props.exportingProperties.prefix = clean ? dealers.assets?.prefix : selectedFolder;
    onExportingPropsChange(props.exportingProperties);    
    updateAssetsNames(undefined, props.exportingProperties.prefix??"");
  }

  const navigateToFolder = (folderIndex: number) => {
    const navigationFolders = dealers.assets?.prefix?.split("/") ?? [];
    navigationFolders.splice(folderIndex + 1, navigationFolders.length - folderIndex);
    const prefix = navigationFolders.join("/") + "/";
    updateAssets(prefix);
  }

  const handleClose = () => {
    props.setOpenGalleryExport(false);
  }

  const handleCloseOverwrite = () => {    
    updateArtboardsExportingNames();
    setOverwriteAssets(false);
  }

  const handleExportOverwrite = () => {
    
    if (hasChanges)
    {
      let newNames = props.exportingProperties.names && props.exportingProperties.names.map(n=>{
        return n.savename
      });    
      updateAssetsNames(newNames, props.exportingProperties.prefix??"");
    }
    else
      props.onExport();    
  }
  


  const handleExport = () => {
    //if (overwriteAssets)
    //if (props.exportingProperties.askOverwrite)
    if (askOverwrite && !folderName)
    {      
      setOverwriteAssets(true);      
      setAskOverwrite(false);
    }
    else    
      props.onExport(newFolderControls ? folderName : undefined);
    
  }

  const handleOpenEmptyFolder = () => {
    if (folderName !== "" && !repeatedName) {
      setEmptyFolderPrefix(`${dealers.assets?.prefix ?? ""}${folderName.trim()}/`);
    }
  }

  const updateArtboardsExportingNames = () =>{
    
    if (props.exportingProperties && props.exportingProperties.names )
    {
      let ask = false;
      let newExportingNames = props.exportingProperties.names.map((n, i)=>{

        let newname = dealers.assetsNames?dealers.assetsNames[i]:n.name;
        ask = n.name!= newname;
        return{
          id: n.id,
          name: n.name,
          savename: newname,
          url: dealers.assetsUrls? dealers.assetsUrls[i]:"",
          overwrite: false,
          changed:false
        }
      });      
      props.exportingProperties.names = newExportingNames;      
      onExportingPropsChange(props.exportingProperties)      
      setAskOverwrite(ask);      
      setHasChanges(false);      
    }
  
  }

  React.useEffect(() => {
    if (dsConfig) {
      const sum = editorStatus.exportingSizes.map(e => e.size).reduce((partialSum, s) => (partialSum + s), 0);
      if (sum > dsConfig.editorConfig.exportingValues.folderStorageMaxSize * Math.pow(1024, 2)) setOvercomeSize(true);
      else (setOvercomeSize(false));
    }
  }, []);

  React.useEffect(() => {    
    setIsUpdatingNamesAssets(false);
    updateArtboardsExportingNames();
  }, [dealers.assetsNames]);


  React.useEffect(() => {
    updateCollections();
  }, [dealers.selectedDealer?.id]);

  React.useEffect(() => {
    updateAssets();
  }, [selectedCollection?.id]);

  React.useEffect(() => {
    if (selectedFolder)
    {
       updatePrefix();       
    }
  }, [selectedFolder]);

  const renderNavigation = () => {
    const navigationFolders = emptyFolderPrefix?.split("/") ?? dealers.assets?.prefix?.split("/") ?? [];
    navigationFolders.splice(-1, 1);
    return navigationFolders.map((folderPrefix, index) => {
      const isLastItem = index === navigationFolders.length - 1;
      return (
        <S.NavigationItemContainer key={index} >
          <S.NavigationDivider>
            {">"}
          </S.NavigationDivider>
          <S.NavigationItem
            enableValue={!isLastItem && !isSearchingAssets}
            onClick={() => {if (!isLastItem && !isSearchingAssets) navigateToFolder(index)}}
          >
            {folderPrefix}
          </S.NavigationItem>
        </S.NavigationItemContainer>
      );
    });
  }

  const handleChangeNames = (exportingNames:IExportingArtboardNames[])=>{  

    
    props.exportingProperties.names?.map(n=>{
      if (n.changed)
      {
        setHasChanges(true);
      }
    })
    
    props.exportingProperties.names = exportingNames;
    onExportingPropsChange(props.exportingProperties);
    //setAskOverwrite(true);
  }

  const isNotAllowedCollection = (): boolean => {
    if (!selectedCollection) {
      return false;
    }

    return authContext.userData?.profile.role === IUserType.DEALER_USER && (
      selectedCollection?.name.includes(NOT_ALLOWED_COLLECTIONS.OEM) || 
      selectedCollection?.name.includes(NOT_ALLOWED_COLLECTIONS.DEALER_ON) || 
      selectedCollection?.name.includes(NOT_ALLOWED_COLLECTIONS.STOCK_PHOTOS));
  };

  const disabledExport = ()=>{
    return overcomeSize ||
    (folderName === "" && newFolderControls) ||
    repeatedName ||
    (dealers.collections && !isUpdatingNamesAssets ? props.exportingProperties.collection === undefined:true) ||
    isNotAllowedCollection()
  }

  return (
    
   
    <S.Root>
    {
      overwriteAssets?
      <>
      <S.Title>
      Files already exists with these names. Rename it or it will be saved as a copy. You can also choose to replace the existing file with this one.  
      </S.Title>
      <AssetsNames
        format={props.exportingProperties.format}
        names={props.exportingProperties.names}
        changeNames={(exportingNames:IExportingArtboardNames[])=> handleChangeNames(exportingNames)}        
      ></AssetsNames>
      <S.BottomContainer>
        <S.ActionsContainer>
          <Button
            label={"CANCEL"}
            style={{
              width: "120px",
              marginRight: "20px",
              hoverBackgroundColor: "#344a70", 
              backgroundColor: "#366cc8", 
              boxShadow: "0 3px 6px 0 rgba(0, 0, 0, 0.16)",
            }} 
            onClick={handleCloseOverwrite}
          />
          <Button
            label={"EXPORT"}            
            style={{
              width: "120px",
              hoverBackgroundColor: "#344a70", 
              backgroundColor: "#366cc8", 
              boxShadow: "0 3px 6px 0 rgba(0, 0, 0, 0.16)",
            }} 
            onClick={handleExportOverwrite}
          />
        </S.ActionsContainer>
      </S.BottomContainer>
      </>  
      :
      <>
      <S.Title>
        Search for the dealer and select the folder you would like to export to
      </S.Title>
      <S.TopContent>
        <S.ComboColumnContainer>
          <S.ComboTitle>
            Search Dealers
          </S.ComboTitle>
          <DealerSelect />
        </S.ComboColumnContainer>
        {
          dealers.collections &&
          <S.ComboColumnContainer>
            <S.ComboTitle>
              Select Collection <b>{"(Required)"}</b>
            </S.ComboTitle>
            <ComboBox
              id="dealer-collections"
              placeholder="Select a collection"
              options={dealers.collections.map(c => c.name)}
              required={false}
              disabled={isSearchingCollections}
              position={"bottom"}
              chooseOption={handleSelectCollection}
              value={selectedCollection?.name ?? ""}
              containerStyle={{ paddingTop: "0px" }}
              boxContainerStyle={{ height: "42px" }}
              style={{ color: "#373f53", fontSize: "14px" }}
              optionContainerStyle={{ 
                top: "46px",
                maxHeight: "278px",
                padding: "0px",
                border: "solid 1px rgba(130,130,130,0.5)",
              }}
              optionStyle={{
                minHeight: "47px",
                fontSize: "14px",
                color: "#373f53",
                display: "flex",
                alignItems: "center",
              }}
            />
          </S.ComboColumnContainer>
        }
      </S.TopContent>
      <S.MiddleContent>
        <S.NavigationContainer
          isNavigating={isSearchingAssets}
        >
          {
            (dealers.assets?.prefix || emptyFolderPrefix) &&
            <>
              <S.NavigationItem
                enableValue={!isSearchingAssets}
                onClick={() => {if (!isSearchingAssets) updateAssets()}}
              >
                {"/"}
              </S.NavigationItem>
              { renderNavigation() }
            </>
          }
        </S.NavigationContainer>
        {
          (dealers.assets && selectedCollection?.id && !isSearchingAssets && !emptyFolderPrefix) &&
          (isNotAllowedCollection()
            ? (
              <S.EmptyFolderContainer>
                <S.NotAllowedCollectionMessage>
                  This folder is readonly 
                </S.NotAllowedCollectionMessage>
              </S.EmptyFolderContainer>
            ) : (
              <AssetsExplorer
                selectedFolder={selectedFolder}
                setSelectedFolder={setSelectedFolder}
                newFolderControls={newFolderControls}
                setNewFolderControls={setNewFolderControls}
                folderName={[folderName, setFolderName]}
                repeatedName={[repeatedName, setRepeatedName]}
                emptyFolderPrefix={[emptyFolderPrefix, setEmptyFolderPrefix]}
                handleOpenEmptyFolder={handleOpenEmptyFolder}
                assetsObject={dealers.assets}
                updateAssets={updateAssets}
                updatePrefix={updatePrefix}
              />
            )
          )
        }
        {
          emptyFolderPrefix &&
          <S.EmptyFolderContainer>
            <S.EmptyFolderMessage>
              This folder will only be created after at least one asset is exported to it. Otherwise, the folder will not be added.
            </S.EmptyFolderMessage>
          </S.EmptyFolderContainer>
        }
        {
          isSearchingAssets &&
          <Loading />
        }
      </S.MiddleContent>
      <S.BottomContainer>
        <S.ActionsContainer>
          <Button
            label={"CANCEL"}
            style={{
              width: "120px",
              marginRight: "20px",
              hoverBackgroundColor: "#344a70", 
              backgroundColor: "#366cc8", 
              boxShadow: "0 3px 6px 0 rgba(0, 0, 0, 0.16)",
            }} 
            onClick={handleClose}
          />
          <Button
            label={"EXPORT"}
            //disabled={dealers.collections? props.exportingProperties.collection==undefined:true}
            disabled={disabledExport()}
            style={{
              width: "120px",
              hoverBackgroundColor: "#344a70", 
              backgroundColor: "#366cc8", 
              boxShadow: "0 3px 6px 0 rgba(0, 0, 0, 0.16)",
            }} 
            onClick={handleExport}
          />
        </S.ActionsContainer>
        {  
          ((newFolderControls && !emptyFolderPrefix) || overcomeSize) &&
          <S.WarningMessageContainer>
            {
              overcomeSize ?
              <S.WarningMessage>
                {`Error: Unable to export files over ${dsConfig?.editorConfig.exportingValues.folderStorageMaxSize}MB`}
                <WarningIcon />
              </S.WarningMessage>
              : 
              <S.WarningMessage>
                This folder will only be created after at least one asset is exported to it. Otherwise, the folder will not be added.
              </S.WarningMessage>
            }
          </S.WarningMessageContainer>
        }
      </S.BottomContainer>
      </>
      
    }
      
     
    </S.Root>
  );
}

export default GalleryExport;